import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="Logo"
      src="/static/cr-logo.png"
      {...props}
      width="50"
      height="50"
    />
  );
};

export default Logo;
